import { ICON_TYPES } from '../constants';

export const ArrowRightTriangle = (): JSX.Element => {
  return (
    <svg
      width="8"
      height="10"
      viewBox="0 0 8 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 4.99316L0 10V0L8 4.99316Z" fill="#0F3E32" />
    </svg>
  );
};

ArrowRightTriangle.iconType = ICON_TYPES.ARROW_RIGHT_TRIANGLE;
